import React from "react";
import { CheckCircle2, Sparkles } from "lucide-react";
import { motion } from "framer-motion";
import firstBadge from "../../assets/first.png";
import secondBadge from "../../assets/second.png";
import thirdBadge from "../../assets/third.png";

export const PrizesSection: React.FC = () => {
  const prizes = [
    {
      place: "BİRİNCİLİK",
      amount: "₺75.000",
      perks: [
        "Jüri geri bildirim raporu",
        "Kapsül ekosistemi görünürlüğü",
      ],
      image: firstBadge,
      featured: true,
    },
    {
      place: "İKİNCİLİK",
      amount: "₺50.000",
      perks: [ "Jüri geri bildirim raporu"],
      image: secondBadge,
    },
    {
      place: "ÜÇÜNCÜLÜK",
      amount: "₺30.000",
      perks: [ "Jüri geri bildirim raporu"],
      image: thirdBadge,
    },
  ];
  const criteria = [
    "Yenilikçilik ve Özgünlük",
    "Teknik Yeterlilik ve Algoritma",
    "Uygulanabilirlik ve Saha Uyumu",
    "Sürdürülebilirlik ve İş Modeli",
    "Sunum Becerisi ve İfade",
  ];

  return (
    <section id="prizes" className="section-shell bg-[var(--bg-primary)]">
      <div className="max-w-6xl mx-auto">
        <div className="mb-14 text-center">
          <h2 className="text-4xl sm:text-5xl font-black text-[var(--text-primary)] mb-4">Ödüller</h2>
          <div className="w-24 h-1 mx-auto rounded-full bg-[#73E03A]" />
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto items-stretch">
          {prizes.map((prize, idx) => (
            <motion.article
              key={prize.place}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -8, scale: 1.02 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.08, type: "spring", stiffness: 180, damping: 18 }}
              className={`group relative rounded-2xl px-6 py-7 border overflow-hidden ${
                prize.featured
                  ? "text-white border-[#73E03A] shadow-[0_0_34px_rgba(115,224,58,0.22)] md:scale-105"
                  : "kapsul-card hover:border-[#8FD92F]/60 hover:shadow-[0_12px_32px_rgba(80,140,54,0.18)]"
              }`}
              style={prize.featured ? { background: "linear-gradient(145deg,#234315,#1C3512)" } : undefined}
            >
              {!prize.featured && (
                <div className="absolute inset-x-0 top-0 h-1.5 bg-[#73E03A]" />
              )}
              {prize.featured && (
                <span className="absolute -top-4 left-1/2 -translate-x-1/2 px-3 py-1 text-xs font-bold kapsul-badge text-[#14300A]" style={{ background: "linear-gradient(90deg,#E8F974,#73E03A)" }}>
                  BÜYÜK ÖDÜL
                </span>
              )}
              <div className="mb-4 flex items-center justify-between">
                <h3 className={`text-xs font-semibold tracking-[0.2em] uppercase ${prize.featured ? "text-white/70" : "text-[var(--text-secondary)]"}`}>{prize.place}</h3>
              </div>
              <div
                className="mb-5 rounded-2xl border p-3 shadow-[inset_0_1px_0_rgba(255,255,255,0.45)]"
                style={{
                  borderColor: "rgba(115,224,58,0.35)",
                  background: "linear-gradient(165deg, rgba(249,255,245,0.96), rgba(232,247,224,0.9))",
                }}
              >
                <img
                  src={prize.image}
                  alt={`${prize.place} rozet`}
                  className="h-36 w-full object-contain transition-transform duration-300 group-hover:scale-105 group-hover:-translate-y-1"
                />
              </div>
              <p className="text-4xl font-black mb-5">{prize.amount}</p>
              <ul className="space-y-2 min-h-[56px]">
                {prize.perks.map((perk) => (
                  <li key={perk} className="flex gap-2 items-start text-sm">
                    <CheckCircle2 className="w-4 h-4 mt-0.5 text-[#57B92B]" />
                    <span>{perk}</span>
                  </li>
                ))}
              </ul>
            </motion.article>
          ))}
        </div>

        <div className="mt-10 rounded-2xl border p-5" style={{ borderColor: "rgba(115,224,58,0.35)", backgroundColor: "rgba(115,224,58,0.06)" }}>
          <h3 className="text-center text-xl font-bold text-[var(--text-primary)] mb-4">
            Jüri Değerlendirme Kriterleri
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {criteria.map((award, idx) => (
              <motion.div
                key={award}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.06 }}
                className="kapsul-card p-4 flex items-center gap-2 hover:-translate-y-1"
                style={{ borderColor: "rgba(115,224,58,0.35)" }}
              >
                <Sparkles className="w-4 h-4 text-[#57B92B]" />
                <span className="text-sm text-[var(--text-primary)] font-medium">{award}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
